import React from 'react';
import classNames from 'classnames';
import { Theme } from '../../../../helpers/enums/themes/themeTypes.js';
import { ArrowPosition } from '../../../../helpers/enums/themes/arrowPosition.js';
import styles from './Tooltip.scss.js';

const TooltipsAlignOptions = {
  center: 'align-center',
  left: 'align-left',
  right: 'align-right'
};
const Tooltip = _ref => {
  let {
    hasArrow = true,
    arrow = 'bottom-center',
    theme = Theme.DARK,
    align = 'center',
    children,
    customWidth
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: customWidth || '100%'
    },
    className: classNames(styles.container, {
      [styles[`container--${theme}`]]: true,
      [styles[`container--with-arrow`]]: hasArrow,
      [styles[`arrow--${ArrowPosition[arrow]}`]]: hasArrow,
      [styles['np-base']]: true,
      [styles[`container--${TooltipsAlignOptions[align]}`]]: true
    })
  }, children);
};
var Tooltip$1 = Tooltip;

export { TooltipsAlignOptions, Tooltip$1 as default };
//# sourceMappingURL=Tooltip.js.map
